//#region imports
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { CardContent, CircularProgress, Tooltip, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Slider from '@material-ui/core/Slider';

import GridContainer from '../../../../components/Grid/GridContainer';
import GridItem from '../../../../components/Grid/GridItem';
import Button from '../../../../components/CustomButton/Button';
import Portlet from '../../../../components/Portlet/Portlet';
import PortletActions from '../../../../components/Portlet/PorletActions';
import { useFormStyle } from '../../../../common/styles/formStyle';
import { FormNameIcon, FormAlarmShortTime } from '../../../../../assets/icons/formIcons';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';
import * as yup from 'yup';

import { useIntl } from '../../../../lang/context/intlContext';
import CustomCheck from '../../../../components/CustomCheck/CustomCheck';
import { useStoreActions, useStoreState } from 'easy-peasy';
import InputMaskText from '../../../../components/InputMaskText/InputMaskText';
import { postConfiguration } from '../api/postMethods';
import { formatValue } from '../../../../../utils';

//#endregion
//TODO: Icons required:Time,Schedule/Day
//TODO: Slider control

const ContinousTime = ({ error = [], handleNextChange, isReadOnly = true }) => {
  const classes = useFormStyle();
  const { i18, getWeekDays } = useIntl();

  const [free, setfree] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const { handleSubmit, errors } = useForm();

  const [values, setValues] = useState({
    maxContinousDriving: undefined,
    maxDailyDriving: undefined,
    maxWeeklyDriving: undefined,
    preAlertExcessDriving: 0,
    preAlertExcessDrivingChecks: { sendPos: false, sendAlertCabina: false },
    alertExcessDriving: 0,
    alertExcessDrivingChecks: { sendPos: false, sendAlertCabina: false, blockStartVehicle: false },
    detectStoppedVehicle: 0,
    detectStoppedVehicleChecks: { sendPos: false, sendAlertCabina: false, blockRestMacro: false },
  });

  const journeyControlId = useStoreState((state) => state.journeyControl.journeyControlId);
  const continousDurationTime = useStoreState((state) => state.journeyControl.continousDurationTime);
  const setJourneyTime = useStoreActions((actions) => actions.journeyControl.setJourneyTime);
  useEffect(() => {
    setValues((values) => ({ ...values, ...continousDurationTime }));
  }, [continousDurationTime]);

  //#region handlers
  const handleOnChanges = (e) => {
    const value = e.target.value;
    const field = e.target.name;
    setValues((values) => ({
      ...values,
      [field]: value,
    }));
  };
  const handleSliders = (field, newValue) => {
    setValues((prev) => ({ ...prev, [field]: +newValue }));
  };

  /**
   *
   * @param {number} id
   * @param {string} field
   */
  const handleChecks = (id, field) => {
    switch (id) {
      case 0:
        const { preAlertExcessDrivingChecks } = values;
        setValues((prev) => ({
          ...prev,
          preAlertExcessDrivingChecks: { ...preAlertExcessDrivingChecks, [field]: !prev.preAlertExcessDrivingChecks[field] },
        }));
        break;
      case 1:
        const { alertExcessDrivingChecks } = values;
        setValues((prev) => ({
          ...prev,
          alertExcessDrivingChecks: { ...alertExcessDrivingChecks, [field]: !prev.alertExcessDrivingChecks[field] },
        }));
        break;
      case 2:
        const { detectStoppedVehicleChecks } = values;
        setValues((prev) => ({
          ...prev,
          detectStoppedVehicleChecks: { ...detectStoppedVehicleChecks, [field]: !prev.detectStoppedVehicleChecks[field] },
        }));
        break;

      default:
        break;
    }
    // setDetectBeginJourneyChecks((values) => ({ ...values, [name]: !values[name] || false }));
  };

  const onSave = async (data) => {
    try {
      setIsLoading(true);
      const { maxContinousDriving, maxDailyDriving, maxWeeklyDriving } = values;
      const continousDurationTime = {
        ...values,
        maxContinousDriving: formatValue(maxContinousDriving),
        maxDailyDriving: formatValue(maxDailyDriving),
        maxWeeklyDriving: formatValue(maxWeeklyDriving),
      };
      await postConfiguration({ journeyControlId: journeyControlId, continousDurationTime });
      setJourneyTime({ continousDurationTime });
      setIsLoading(false);
    } catch (error) {
      console.error(error);
      console.log('error on save');
      setIsLoading(false);
    }
  };
  //#endregion

  return (
    <form onSubmit={handleSubmit(onSave)}>
      <GridContainer className={classes.content}>
        <GridItem item xs={12} md={12} lg={10} className={classes.content}>
          <Portlet className={classes.formStyle} title={i18('CONTINOUS_TIME')} subTitle={i18('JOURNEY_TIME_DETAIL')}>
            <CardContent>
              <GridContainer direction="column" spacing={2}>
                <GridItem item xs={12} md={12} lg={12}>
                  <GridContainer direction="row" spacing={2}>
                    <GridItem item xs={6} md={6}>
                      <InputMaskText
                        id="maxContinousDriving"
                        name="maxContinousDriving"
                        label={i18('Max_time')}
                        icon={FormAlarmShortTime}
                        value={values.maxContinousDriving}
                        format={'##:##'}
                        mask="_"
                        onChange={handleOnChanges}
                      ></InputMaskText>
                      {free && <Typography color="secondary">{`${free} ${i18('NOTAVAI')}`}</Typography>}
                      {errors.name && <Typography color="secondary">{i18('Name_Req')}</Typography>}
                    </GridItem>
                    <GridItem item xs={6} md={6}>
                      <InputMaskText
                        id="maxDailyDriving"
                        name="maxDailyDriving"
                        label={i18('maxDailyDriving')}
                        value={values.maxDailyDriving}
                        format={'##:##'}
                        mask="_"
                        onChange={handleOnChanges}
                        icon={FormAlarmShortTime}
                      ></InputMaskText>
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem item xs={12} md={12} lg={12}>
                  <GridContainer direction="row" spacing={2}>
                    <GridItem item xs={6} md={6}>
                      <InputMaskText
                        id="maxWeeklyDriving"
                        name="maxWeeklyDriving"
                        label={i18('MAX_EXTRA_HOURS')}
                        icon={FormAlarmShortTime}
                        value={values.maxWeeklyDriving}
                        format={'##:##'}
                        mask="_"
                        onChange={handleOnChanges}
                      ></InputMaskText>
                    </GridItem>
                    <GridItem item xs={6} md={6}></GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem item xs={12} md={12} lg={12}>
                  <GridContainer direction="row" spacing={2}>
                    <GridItem item xs={6} md={6}>
                      <Typography gutterBottom>{i18('preAlertExcessDriving')}</Typography>
                      <Slider
                        id="preAlertExcessDriving"
                        name="preAlertExcessDriving"
                        ValueLabelComponent={ValueLabelComponent}
                        aria-label="custom thumb label"
                        value={values.preAlertExcessDriving}
                        onChange={(_, value) => {
                          handleSliders('preAlertExcessDriving', value);
                        }}
                        min={15}
                        max={120}
                      />
                    </GridItem>
                    <GridItem container direction="row" item xs={6} md={6}>
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('SEND_POS')}
                          checked={values.preAlertExcessDrivingChecks.sendPos}
                          onChange={() => handleChecks(0, 'sendPos')}
                          name="sendPos"
                        />
                      </GridItem>
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('SEND_ALERT_CABINA')}
                          checked={values.preAlertExcessDrivingChecks.sendAlertCabina}
                          onChange={() => handleChecks(0, 'sendAlertCabina')}
                          name="sendAlertCabina"
                        />
                      </GridItem>
                    </GridItem>
                  </GridContainer>
                </GridItem>{' '}
                <GridItem item xs={12} md={12} lg={12}>
                  <GridContainer direction="row" spacing={2}>
                    <GridItem item xs={6} md={6}>
                      <Typography gutterBottom>{i18('alertExcessDriving')}</Typography>
                      <Slider
                        id="alertExcessDriving"
                        name="alertExcessDriving"
                        ValueLabelComponent={ValueLabelComponent}
                        aria-label="custom thumb label"
                        value={values.alertExcessDriving}
                        onChange={(_, value) => {
                          handleSliders('alertExcessDriving', value);
                        }}
                        min={0}
                        max={60}
                      />
                    </GridItem>
                    <GridItem container direction="row" item xs={6} md={6}>
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('SEND_POS')}
                          checked={values.alertExcessDrivingChecks.sendPos}
                          onChange={() => handleChecks(1, 'sendPos')}
                          name="sendPos"
                        />
                      </GridItem>
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('SEND_ALERT_CABINA')}
                          checked={values.alertExcessDrivingChecks.sendAlertCabina}
                          onChange={() => handleChecks(1, 'sendAlertCabina')}
                          name="sendAlertCabina"
                        />
                      </GridItem>{' '}
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('blockStartVehicle')}
                          checked={values.alertExcessDrivingChecks.blockStartVehicle}
                          onChange={() => handleChecks(1, 'blockStartVehicle')}
                          name="blockStartVehicle"
                        />
                      </GridItem>
                    </GridItem>
                  </GridContainer>
                </GridItem>
                <GridItem item xs={12} md={12} lg={12}>
                  <GridContainer direction="row" spacing={2}>
                    <GridItem item xs={6} md={6}>
                      <Typography gutterBottom>{i18('detectStoppedVehicle')}</Typography>
                      <Slider
                        id="detectStoppedVehicle"
                        name="detectStoppedVehicle"
                        ValueLabelComponent={ValueLabelComponent}
                        aria-label="custom thumb label"
                        value={values.detectStoppedVehicle}
                        onChange={(_, value) => {
                          handleSliders('detectStoppedVehicle', value);
                        }}
                        min={0}
                        max={60}
                      />
                    </GridItem>
                    <GridItem container direction="row" item xs={6} md={6}>
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('SEND_POS')}
                          checked={values.detectStoppedVehicleChecks.sendPos}
                          onChange={() => handleChecks(2, 'sendPos')}
                          name="sendPos"
                        />
                      </GridItem>
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('SEND_ALERT_CABINA')}
                          checked={values.detectStoppedVehicleChecks.sendAlertCabina}
                          onChange={() => handleChecks(2, 'sendAlertCabina')}
                          name="sendAlertCabina"
                        />
                      </GridItem>{' '}
                      <GridItem item xs={3} md={3}>
                        <CustomCheck
                          label={i18('blockRestMacro')}
                          checked={values.detectStoppedVehicleChecks.blockRestMacro}
                          onChange={() => handleChecks(2, 'blockRestMacro')}
                          name="blockRestMacro"
                        />
                      </GridItem>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </CardContent>
            <PortletActions>
              <div className={classes.div}>
                <div className={classes.inDiv}>
                  <Button
                    variant="contained"
                    disabled={isLoading || isReadOnly}
                    color={'cancel'}
                    onClick={() => handleNextChange(0)}
                  >
                    {i18('Cancel')}
                  </Button>
                </div>
                <div className={classes.inDiv}>
                  <Button type="submit" disabled={isLoading || isReadOnly} variant="contained" color={'primary'}>
                    {i18('save')}
                  </Button>
                  {isLoading && <CircularProgress size={24} className={classes.buttonProgress} />}
                </div>
              </div>
            </PortletActions>
            {error.length > 0 && (
              <Alert className={classes.alert} severity="error">
                {i18('API_ERR')}
              </Alert>
            )}
          </Portlet>
        </GridItem>
      </GridContainer>
    </form>
  );
};

function ValueLabelComponent(props) {
  const { children, open, value } = props;

  return (
    <Tooltip title={<h1 style={{ fontSize: '14px' }}>{value}</h1>} open={true} enterTouchDelay={0} placement="top">
      {children}
    </Tooltip>
  );
}

ValueLabelComponent.propTypes = {
  children: PropTypes.element.isRequired,
  open: PropTypes.bool.isRequired,
  value: PropTypes.number.isRequired,
};
export default ContinousTime;
